import React, { createContext, useMemo } from 'react';
import { useTheme } from '@mui/material/styles';
import { CHART_THEME_MODE } from './const';
import { CHART_THEMES } from './themes';
import { ChartTheme } from './themes/types';
import { lightChartTheme } from './themes/light';

export const ChartThemeContext = createContext<ChartTheme>(lightChartTheme);

interface Props {
  children: React.ReactNode;
}

const ChartThemeProvider = ({ children }: Props) => {
  const theme = useTheme();

  const chartTheme = useMemo(
    () => CHART_THEMES[theme.palette.mode === 'dark' ? CHART_THEME_MODE.DARK : CHART_THEME_MODE.LIGHT],
    [theme.palette.mode],
  );

  return (
    <ChartThemeContext.Provider value={chartTheme}>
      {children}
    </ChartThemeContext.Provider>
  );
};

export default ChartThemeProvider;
